(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.hb-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-hb-carousel]').forEach(function (c) {
      if (c.dataset.hbReady) return; c.dataset.hbReady = '1';
      var track = c.querySelector('[data-hb-track]');
      c.querySelectorAll('[data-hb-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.querySelector(':scope > *');
          var step = card ? card.getBoundingClientRect().width + 20 : 300;
          track.scrollBy({ left: step * 2 * Number(b.dataset.hbDir), behavior: 'smooth' });
        });
      });
    });
  }
  function init(root) { initReveal(root); initCarousels(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
